import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { API_URL } from '../env';

const fieldStyle: React.CSSProperties = {
  width: '100%',
  background: '#0f172a',
  border: '1px solid rgba(148,163,184,0.2)',
  borderRadius: 8,
  padding: '12px 16px',
  color: '#f9fafb',
  fontSize: '0.95rem',
  outline: 'none',
  boxSizing: 'border-box',
};

const labelStyle: React.CSSProperties = {
  display: 'block',
  color: '#94a3b8',
  fontSize: '0.85rem',
  fontWeight: 600,
  marginBottom: 8,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
};

const ContactSalesPage: React.FC = () => {
  const [name, setName] = useState('');
  const [workEmail, setWorkEmail] = useState('');
  const [company, setCompany] = useState('');
  const [approxAccounts, setApproxAccounts] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSending(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/contact/sales`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: name.trim(),
          workEmail: workEmail.trim(),
          company: company.trim(),
          approxAccounts: approxAccounts.trim() || undefined,
          message: message.trim(),
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.message || 'Failed to send inquiry');
      setDone(true);
    } catch (err: any) {
      setError(err?.message || 'Failed to send inquiry');
    } finally {
      setSending(false);
    }
  };

  return (
    <main style={{ paddingTop: 100 }}>
      <div className="container" style={{ maxWidth: 640, margin: '0 auto', padding: '60px 24px 80px' }}>
        <div style={{ marginBottom: 32, textAlign: 'center' }}>
          <h1 style={{ fontSize: 'clamp(1.8rem, 4vw, 2.5rem)', fontWeight: 900, marginBottom: 12 }}>
            Contact sales
          </h1>
          <p style={{ color: '#94a3b8', fontSize: '1rem', lineHeight: 1.7 }}>
            Enterprise plans are tailored — tell us about your team and we will follow up. Commercial
            numbers are not published on the website.
          </p>
        </div>

        <div
          style={{
            background: '#1e293b',
            border: '1px solid rgba(148,163,184,0.15)',
            borderRadius: 16,
            padding: '40px 32px',
          }}
        >
          {done ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', marginBottom: 12 }}>✓</div>
              <h2 style={{ fontWeight: 800, marginBottom: 8 }}>Thanks — we got it</h2>
              <p style={{ color: '#94a3b8', marginBottom: 24 }}>
                Our team will reach out at your work email shortly.
              </p>
              <Link to="/pricing" style={{ color: '#60a5fa' }}>
                Back to pricing
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
              {error && (
                <div
                  style={{
                    background: 'rgba(239,68,68,0.12)',
                    border: '1px solid rgba(239,68,68,0.35)',
                    color: '#fca5a5',
                    padding: '10px 14px',
                    borderRadius: 8,
                    fontSize: '0.9rem',
                  }}
                >
                  {error}
                </div>
              )}

              <div>
                <label style={labelStyle}>Name *</label>
                <input style={fieldStyle} value={name} onChange={(e) => setName(e.target.value)} required />
              </div>
              <div>
                <label style={labelStyle}>Work email *</label>
                <input
                  style={fieldStyle}
                  type="email"
                  value={workEmail}
                  onChange={(e) => setWorkEmail(e.target.value)}
                  required
                />
              </div>
              <div>
                <label style={labelStyle}>Company *</label>
                <input
                  style={fieldStyle}
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
                  required
                />
              </div>
              <div>
                <label style={labelStyle}>Approx. accounts</label>
                <input
                  style={fieldStyle}
                  value={approxAccounts}
                  onChange={(e) => setApproxAccounts(e.target.value)}
                  placeholder="e.g. 100+"
                />
              </div>
              <div>
                <label style={labelStyle}>Message *</label>
                <textarea
                  style={{ ...fieldStyle, minHeight: 120, resize: 'vertical' }}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                  placeholder="Tell us about your volume and timeline…"
                />
              </div>

              <button
                type="submit"
                disabled={sending}
                style={{
                  padding: '14px 24px',
                  borderRadius: 10,
                  border: 'none',
                  background: 'var(--primary-gradient, linear-gradient(135deg,#2563eb,#1d4ed8))',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: '0.95rem',
                  cursor: sending ? 'wait' : 'pointer',
                  opacity: sending ? 0.7 : 1,
                }}
              >
                {sending ? 'Sending…' : 'Send to sales'}
              </button>

              <p style={{ color: '#64748b', fontSize: '0.8rem', margin: 0, textAlign: 'center' }}>
                Looking for general support?{' '}
                <Link to="/contact" style={{ color: '#60a5fa' }}>
                  Contact form
                </Link>
              </p>
            </form>
          )}
        </div>
      </div>
    </main>
  );
};

export default ContactSalesPage;
